import React, { useContext, useRef, useState } from "react";
import "./PortfolioLogos.css";

import projectlogo1 from "../../asset/projectlogo1.png";
import projectlogo2 from "../../asset/projectlogo2.png";
import projectlogo3 from "../../asset/projectlogo3.png";
import projectlogo4 from "../../asset/projectlogo4.png";
import projectlogo5 from "../../asset/projectlogo5.png";
import projectlogo6 from "../../asset/projectlogo6.png";
import projectlogo7 from "../../asset/projectlogo7.png";
import { CanvasContext } from "../../contexts/CanvasContext";

const PortfolioLogos = () => {
  const logos = [
    projectlogo1,
    projectlogo2,
    projectlogo3,
    projectlogo4,
    projectlogo5,
    projectlogo6,
    projectlogo7,
    projectlogo1,
    projectlogo2,
    projectlogo3,
    projectlogo4,
    projectlogo5,
    projectlogo6,
    projectlogo7,
  ];

  const { isDarkTheme } = useContext(CanvasContext);

  const containerRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  const handleMouseDown = (e) => {
    setIsDragging(true);
    setStartX(e.pageX - containerRef.current.offsetLeft);
    setScrollLeft(containerRef.current.scrollLeft);
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - containerRef.current.offsetLeft;
    const walk = (x - startX) * 2;
    containerRef.current.scrollLeft = scrollLeft - walk;
  };

  const handleMouseUpOrLeave = () => {
    setIsDragging(false);
  };

  return (
    <div
      className={`portfolio-logos-container ${isDarkTheme ? "dark-theme" : ""}`}
    >
      <div
        className={`animation-box ${isDarkTheme ? "dark-theme" : ""} ${
          isDragging ? "animation-box--grabbing" : ""
        }`}
        ref={containerRef}
        onMouseDown={handleMouseDown}
        onMouseMove={handleMouseMove}
        onMouseUp={handleMouseUpOrLeave}
        onMouseLeave={handleMouseUpOrLeave}
      >
        <div className="logos-container">
          {logos.map((logo, index) => (
            <div key={index} className="logo-box">
              <img
                src={logo}
                alt={`Logo ${index + 1}`}
                className={`logo-image ${isDarkTheme ? "dark-theme" : ""}`}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PortfolioLogos;
